function getNonInlineMediaLayoutStyles({
  horizontalAlign,
  mediaWidth
}) {
  return {
    outerStyle: {
      display: "flex",
      justifyContent: horizontalAlign,
      margin: "12px 0"
    },
    innerStyle: {
      width: "100%"
    },
    mediaContainerStyle: {
      display: "flex",
      justifyContent: horizontalAlign,
      width: "100%"
    },
    mediaColumnStyle: {
      display: "flex",
      flexDirection: "column",
      width: mediaWidth,
      maxWidth: "100%"
    }
  };
}
function getBlockMarginWithOptionalTopSuppression({
  suppressTopMargin,
  top = 12,
  bottom = 12
}) {
  return suppressTopMargin ? `0 0 ${bottom}px 0` : `${top}px 0 ${bottom}px 0`;
}
export {
  getBlockMarginWithOptionalTopSuppression as a,
  getNonInlineMediaLayoutStyles as g
};
